export const parseGeminiMessage = (rawText) => {
  console.log("parseGeminiMessage rawText", rawText);
    const lines = rawText.split('\n').filter(line => line.trim() !== '');
  
    return lines.map((line, index) => {
      // Case 1: "*   **Label:** Value"
      const labeledMatch = line.match(/^\*\s*\*\*(.+?):?\*\*:?[\s-]*(.+)/);
      if (labeledMatch) {
        const [, label, value] = labeledMatch;
        return (
          <li key={index}>
            <strong>{label}</strong> {value}
          </li>
        );
      }
  
      // Case 2: "*   "Quote or sentence as bullet point""
      const quoteMatch = line.match(/^\*\s+"(.+)"$/);
      if (quoteMatch) {
        return (
          <li key={index}>
            {quoteMatch[1]}
          </li>
        );
      }
  
      

      // Case 4: Numbered list like "1. **Title**: Description"
    const numberedMatch = line.match(/^\d+\.\s*\*\*(.+?)\*\*:?[\s-]*(.+)/);
    if (numberedMatch) {
      const [, title, description] = numberedMatch;
      return(
        <li key={`numbered-${index}`} className="numbered-title">
          <strong>{title}</strong> {description}
        </li>
      );
    }
    // Case 5: Numbered full-bold titles like `1.  **"Title with colon"**`
        const numberedBoldTitleMatch = line.match(/^\d+\.\s*\*\*(.+?)\*\*\s*$/);
        if (numberedBoldTitleMatch) {
        const [_, title] = numberedBoldTitleMatch;
        return(
            <li key={`numbered-title-${index}`} className="numbered-title">
            <strong>{title}</strong>
            </li>
        );
    }

    // Case 6: bulleted full-bold titles like `1.  **"Title with colon"**`
    const bulletedBoldTitleMatch = line.match(/^\*\s*\*\*(.+?)\*\*\s*$/);
    if (bulletedBoldTitleMatch) {
    const [_, title] = bulletedBoldTitleMatch;
    return(
        <li key={`bulleted-title-${index}`}>
        <strong>{title}</strong>
        </li>
    );
    }
    // Case 3: "*   Anything else" (non-quote bullets)
    const plainBulletMatch = line.match(/^\*\s+(.*)/);
    if (plainBulletMatch) {
      return (
        <li key={index}>
          {plainBulletMatch[1]}
        </li>
      );
    }

      // Default: Paragraph
      return <p key={index}>{line}</p>;
    });
  };